export default __webpack_public_path__ + "images/B9.27b6cba.png";